var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendEmailDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_6054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.039 31.116L44.433 26.516L46.309 13.531C46.3166 13.4902 46.3077 13.448 46.2843 13.4137C46.2609 13.3794 46.2248 13.3558 46.184 13.348H46.173C46.1485 13.3455 46.1238 13.3482 46.1004 13.3558C46.077 13.3633 46.0554 13.3757 46.037 13.392L37.106 21.417L36.355 20.894C35.9526 20.614 35.4742 20.4639 34.984 20.4639C34.4938 20.4639 34.0153 20.614 33.613 20.894L18.929 31.116C18.6252 31.3275 18.3769 31.6092 18.2052 31.9372C18.0335 32.2652 17.9436 32.6298 17.943 33V52.15C17.943 52.76 18.1853 53.345 18.6166 53.7763C19.048 54.2077 19.633 54.45 20.243 54.45H49.725C50.335 54.45 50.92 54.2077 51.3513 53.7763C51.7827 53.345 52.025 52.76 52.025 52.15V33C52.0244 32.6298 51.9345 32.2652 51.7628 31.9372C51.5911 31.6092 51.3428 31.3275 51.039 31.116Z",
    fill: "url(#paint0_linear_1623_6054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.945 26.428L28.629 16.2C29.0313 15.92 29.5098 15.7699 30 15.7699C30.4902 15.7699 30.9686 15.92 31.371 16.2L46.055 26.428C46.3592 26.6398 46.6078 26.922 46.7795 27.2505C46.9512 27.5791 47.0409 27.9443 47.041 28.315V39.232H12.959V28.315C12.9591 27.9443 13.0488 27.5791 13.2205 27.2505C13.3922 26.922 13.6407 26.6398 13.945 26.428Z",
    fill: "#072146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.784 37.468L12.959 29.918V47.462C12.959 48.072 13.2013 48.657 13.6326 49.0883C14.064 49.5197 14.649 49.762 15.259 49.762H27.3C27.9577 49.762 28.5885 49.5007 29.0536 49.0356C29.5187 48.5705 29.78 47.9397 29.78 47.282L29.784 37.468Z",
    fill: "#004481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2159 37.468L47.0409 29.918V47.462C47.0409 48.072 46.7986 48.657 46.3673 49.0883C45.936 49.5197 45.3509 49.762 44.7409 49.762H32.6999C32.0422 49.762 31.4114 49.5007 30.9463 49.0356C30.4812 48.5705 30.2199 47.9397 30.2199 47.282L30.2159 37.468Z",
    fill: "#004481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.041 47.282L31.265 36.9C30.8894 36.6527 30.4496 36.5209 30 36.5209C29.5503 36.5209 29.1105 36.6527 28.735 36.9L12.959 47.282V47.462C12.959 48.072 13.2013 48.657 13.6326 49.0883C14.064 49.5197 14.649 49.762 15.259 49.762H44.741C45.351 49.762 45.936 49.5197 46.3673 49.0883C46.7987 48.657 47.041 48.072 47.041 47.462V47.282Z",
    fill: "#043263"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.781 10.285L22.115 27.058C22.0835 27.0867 22.0646 27.1267 22.0626 27.1692C22.0605 27.2118 22.0754 27.2534 22.104 27.285C22.1205 27.3059 22.1433 27.321 22.169 27.328L28.33 29.535L29.914 30.99L30.866 30.444L37.611 32.861C37.6487 32.8759 37.6907 32.8755 37.7281 32.8598C37.7655 32.8441 37.7952 32.8144 37.811 32.777C37.811 32.777 37.811 32.767 37.816 32.761C37.821 32.755 37.823 32.74 37.827 32.729L41.05 10.422C41.0537 10.4018 41.0534 10.381 41.0491 10.3609C41.0448 10.3408 41.0365 10.3217 41.0248 10.3048C41.0131 10.2879 40.9982 10.2734 40.9809 10.2623C40.9636 10.2512 40.9442 10.2436 40.924 10.24H40.915C40.8907 10.2378 40.8663 10.2407 40.8432 10.2485C40.8202 10.2562 40.799 10.2686 40.781 10.285Z",
    fill: "#2DCCCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2279 13.568L29.9139 31L30.8659 30.454C30.8659 30.454 39.2339 13.573 39.2279 13.568Z",
    fill: "#02A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.228 13.568L29.914 31L28.33 29.54C28.33 29.54 39.223 13.562 39.228 13.568Z",
    fill: "#028484"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1623_6054",
    x1: 27.023,
    y1: 23.494,
    x2: 44.985,
    y2: 57.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C2645",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2645",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_6054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailDark);
export default __webpack_public_path__ + "static/media/send-email-dark.6362c3b19a614c512d94d46a2be12898.svg";
export { ForwardRef as ReactComponent };